import { Component } from '@angular/core';
import { DownloadService, DownloadStatus } from '../services/download.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-download-progress',
    templateUrl: './download-progress.component.html',
    styleUrls: ['./download-progress.component.scss'],
    standalone: false
})
export class DownloadProgressComponent {
    activeDownloads$: Observable<DownloadStatus[]>;

    constructor(private readonly downloadService: DownloadService) {
        this.activeDownloads$ = this.downloadService.activeDownloads$;
    }
}
